<template>

  <div class="bg-overlay no-drawer"></div>
  <div class="slide-over">
  
    <div class="auth-header">
      <div class="auth-heading">
        <h1>Verification</h1>
        <p class="auth-subtext">
          We will send you a one time password on this
          <span v-if="loginType == 'email'">email </span>
          <span v-else>mobile number </span>
          <strong class="login">{{ login }}</strong>
          <span v-if="loginType == 'email'"><br />(Please check your spam folder)</span>
        </p>
      </div>
    </div>

    <el-form class="full_page" :model="formsData.authForm" :rules="formsData.authForm.rules"
      :ref="(el) => (formsData.authForm.ref = el)" :label-position="'top'" @submit.prevent="goNext('authForm')"
      @keyup.enter="goNext('authForm')">
     
      <confirm-code></confirm-code>
      <el-button type="link" class="confirm_numbers_resend" @click="onResendConfirmationCode">
        <i class="el-icon-refresh-left"></i>
        <span>Resend</span>
      </el-button>
      <el-form-item class="button_submit mb0">
        <el-button class="submit" type="blue" @click="goNext('authForm')" :disabled="formsData.authForm.disabled">
          Verify
        </el-button>
      </el-form-item>
    </el-form>
  </div>

  <!-- dummy background screen -->
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button class="button_back">
        <ion-icon name="arrow-back-outline"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
  <template v-if="loginType == 'email'">
    <div class="main_wrapper reset-wrapper ion-padding">
      <div class="container">
        <div class="auth-header">
          <div class="auth-heading">
            <h1>Create Password</h1>
            <p class="auth-subtext">Let’s create a new password!</p>
          </div>
          <div class="brand-icon">
            <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
          </div>
        </div>

        <el-form class="full_page">

          <el-form-item prop="password" :required="true">
            <el-input type="password" autocomplete="off" placeholder="Enter password" show-password>
              <template #prefix>
                <i class="el-icon-lock"></i>
              </template></el-input>
          </el-form-item>
          <!-- <el-button type="link" class="password_reset ">
            <span>Forgot password?</span>
          </el-button> -->
          <el-form-item prop="checkPassword" :required="true" class="no-scroll">
            <el-input type="password" autocomplete="off" placeholder="Re-enter your password" show-password>
              <template #prefix>
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item class="button_submit mb0">
            <el-button class="submit" :type="'blue'">
              <span>Save</span>
            </el-button>
          </el-form-item>
        </el-form>

        <div class="background-circles">
          <div class="circle circle-2"></div>
          <div class="circle circle-1"></div>
        </div>
      </div>
    </div>
  </template>
  <template v-else>
    <div class="main_wrapper ion-padding no-scroll">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Add Mobile No.</h1>
                    <p class="auth-subtext">For your security, we need to verify
                        your phone number.</p>
                </div>
                <div class="brand-icon">
                  <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none"/>
                </div>
            </div>
            <el-form class="full_page" >
                <el-form-item prop="mobileNumber" :required='true'>
                    <div class="el-input">
                        <vue-tel-input class="el-input__inner no-scroll" :preferredCountries="[$filters.vueTelInput()]" :autoDefaultCountry="false"
                            ></vue-tel-input>
                    </div>
                </el-form-item>
                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="blue">
                        Continue
                    </el-button>
                </el-form-item>
            </el-form>
            <div class="background-circles">
                <div class="circle circle-2"></div>
                <div class="circle circle-1"></div>
                <SvgIcon name="bgIcon" class="bg-icon" width="174" height="174" viewBox="0 0 174 174" fill="none"/>
            </div>
        </div>
    </div>
  </template>

  <!-- dummy background screen -->
  <!-- </div> -->

</template>



<script>
import ConfirmCodeComp from "@/components/ConfirmCode/ConfirmCode";

import { onMounted, inject, provide } from "vue";

import { IonToolbar, IonButton, IonButtons, IonIcon } from "@ionic/vue";

import { addIcons } from "ionicons";

import { arrowBackOutline } from "ionicons/icons";

addIcons({
  "arrow-back-outline": arrowBackOutline,
});

import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import formHooks from "@/hooks/form/form";
import formValidate from "@/hooks/form/validate/validate";

import parsePhoneNumber from "libphonenumber-js/mobile";
import SvgIcon from "@/components/Svg/SvgIcon.vue";

export default {
  components: {
    IonToolbar,
    IonButton,
    IonButtons,
    IonIcon,
    SvgIcon,

    "confirm-code": ConfirmCodeComp,
  },
  setup() {
    const $store = useStore();
    const $router = useRouter();
    const $route = useRoute();
    const setPageClassGlobal = inject("setPageClassGlobal");

    const userData = $store.getters.GET_USER_DATA;
    const email = $store.getters.getVerifyPageData.email || userData.email;
    
    const mobileNumber =
      $store.getters.getVerifyPageData.mobileNumber || userData.mobileNumber;
    
    const formattedMobileNumber = mobileNumber
      ? parsePhoneNumber(mobileNumber).formatInternational()
      : null;
    const emaiVerified = userData.emaiVerified;
    const mobileNumber_verified = userData.mobileNumber_verified;

    const getLoginType = () => {
      if ($route.name == "verify_mobile_number") {
        return "mobileNumber";
      } else if ($route.name == "verify_email") {
        return "email";
      } else if (email && !mobileNumber) {
        return "email";
      } else if (!email && mobileNumber) {
        return "mobileNumber";
      } else if (email && mobileNumber) {
        if (emaiVerified) {
          return "mobileNumber";
        } else if (mobileNumber_verified) {
          return "email";
        }
      }
    };
    const loginType = getLoginType();

    const login = loginType == "email" ? email : formattedMobileNumber;

    const formsDataArray = {
      authForm: {
        confirm: {
          value: null,
          inputsValue: [],
          numberLength: 5,
          currentInput: 0,
          validators: [
            {
              validator: (rule, formField, callback) => {
                formValidate.validate(
                  rule,
                  formField,
                  "confirmNumbers",
                  callback,
                  setFormValidation
                );
              },
              trigger: ["enter"],
            },
          ],
        },
      },
    };

    const onResendConfirmationCode = async () => {
      try {
        if (loginType == "email") {
          await $store.dispatch("SAVE_USER_EMAIL", email);
        } else {
          await $store.dispatch("SAVE_USER_PHONE", {
            phone: mobileNumber,
          });
        }
      } catch (error) {
        console.log(error);
      }
    };

    const goBack = () => {
      if (email && mobileNumber) {
        if (loginType == "email") {
          $router.push({
            name: "auth_email",
          });
        } else {
          $router.push({
            name: "auth_mobile",
          });
        }
      } else {
        (async () => {
          try {
            $store.dispatch("AUTH_LOGOUT");
            $router.push({
              name: "auth",
            });
          } catch (error) {
            console.log("error submit!!");
          }
        })();
      }
    };

    const goNext = (formName) => {
      formsRefs[formName].value.validate((valid) => {
        if (valid) {
          (async () => {
            try {
              let data = {
                code: getFormValues(formName).confirm,
              };
              if (loginType == "email") {
                await $store.dispatch("VERIFY_USER_EMAIL", data);
              } else {
                await $store.dispatch("VERIFY_USER_PHONE", data);
              }

              if ($route.name == "verify_mobile_number") {
                $store.dispatch("clearVerifyPageData", {
                  mobileNumber,
                });
                $router.push({
                  name: "profile",
                });
              } else if ($route.name == "verify_email") {
                $store.dispatch("clearVerifyPageData", {
                  email,
                });
                $router.push({
                  name: "profile",
                });
              } else if (email && mobileNumber) {
                $router.push({
                  name: "auth_name",
                });
              } else if (email) {
                $router.push({
                  name: "auth_mobile",
                });
              } else {
                $router.push({
                  name: "auth_email",
                });
              }
            } catch (error) {
              setFieldError(formName, "confirm", error.message);
              checkFormValidation(formName, true);
              console.log(error);
            }
          })();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    };

    const skip = () => {
      if ($route.name == "verify_mobile_number") {
        $store.dispatch("clearVerifyPageData", {
          mobileNumber,
        });
        $router.push({
          name: "profile",
        });
      } else if ($route.name == "verify_email") {
        $store.dispatch("clearVerifyPageData", {
          email,
        });
        $router.push({
          name: "profile",
        });
      }
    };

    onMounted(() => {
      setPageClassGlobal("global_auth_page global_verify_page");
      setFormRefs();
      formsRefs.authForm.value.$el[0].focus();
      checkFormValidation("authForm", false);
    });

    const {
      checkFormValidation,
      setFormValidation,
      setFieldError,
      getFormValues,
      setFormRefs,
      formsData,
      formsRefs,
    } = formHooks(formsDataArray);

    provide("checkFormValidation", checkFormValidation);
    provide("setFormValidation", setFormValidation);
    provide("formsRefs", formsRefs);
    provide("confirm", formsData.authForm.confirm);
    provide("goNext", goNext);

    return {
      formsData,
      checkFormValidation,
      setFormValidation,
      goBack,
      goNext,
      skip,
      login,
      loginType,
      onResendConfirmationCode,
    };
  },
};
</script>
